import React, { useEffect, useMemo } from "react";
import { Row, Col } from "react-bootstrap";

const roleHierarchy = {
  superadmin: ["assistant superadmin", "manager", "staff", "auditor"],
  "assistant superadmin": ["manager", "staff"],
  manager: ["staff"],
};


const Roles = ({ roles, currentRole }) => {
  const [isMobile, setIsMobile] = React.useState(false);

  const filteredRoles = useMemo(() => {
    const allowedRoles = roleHierarchy[currentRole] || [];
    return roles.filter((roleObj) => allowedRoles.includes(roleObj.role));
  }, [roles, currentRole]);

  function mobileView(params) {
    const mediaQueryList = window.matchMedia(`(max-width: 767px)`);
    if (mediaQueryList.matches) {
      setIsMobile(true)
    } else{
      setIsMobile(false)
    }
  }
  useEffect(() => {
    mobileView();
    window.addEventListener("resize", mobileView)
  },[]);

  return (
    <Row className="mb-4">
      {filteredRoles.map((user) => (
        <Col md={isMobile ? 12 : filteredRoles.length > 1 ? "" : 3} key={user.role} className="card mx-2 mb-2">
          <div className="card-item align-items-center">
            <div className="card-title">
              <div className="item-count">{user.count}</div>
              <div className="item">{user.role}</div>
            </div>
            <div className="icon" style={{ backgroundColor: user.color }}>
              {user.icon}
            </div>
          </div>
        </Col>
      ))}
    </Row>
  );
};

export default Roles;
